<template>
  <v-container fluid>
    <v-layout xs12 align-start row wrap>
      <v-flex xs12 sm12 md12 justify-center>
        <h2 class="ml-2 mb-2">Lista de Farmácias</h2>
        <v-data-table
          :headers="headers"
          :items="$apollo.data.drugstores"
          :loading="$apollo.loading"
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <div class="md8 mr-11 ml-2 row sm10 xs10">
                <v-flex xs3 sm3 md3>
                  <v-text-field
                    v-model="filters.name"
                    flat
                    hide-details
                    label="Nome"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 sm3 md3>
                  <v-text-field
                    v-model="filters.description"
                    flat
                    hide-details
                    label="Descrição"
                  ></v-text-field>
                </v-flex>
              </div>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark class="mb-2" v-on="on"
                    >Adicionar</v-btn
                  >
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form
                        ref="form"
                        v-model="valid"
                        :lazy-validation="lazy"
                      >
                        <v-row>
                          <v-col cols="6" md="6">
                            <v-text-field
                              v-model="editedItem.name"
                              id="name"
                              label="Nome*"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.description"
                              id="description"
                              label="Descrição"
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.address.zip"
                              id="zip"
                              label="CEP*"
                              :rules="cepRules"
                              v-on:keyup="loadCep"
                              :mask="'##.###-###'"
                              required
                            >
                            </v-text-field>
                            <span style="color: #ff5252;" v-show="errorCep"
                              ><strong>* CEP não encontrado</strong></span
                            >

                            <v-text-field
                              v-model="editedItem.address.state"
                              id="state"
                              label="Estado*"
                              :rules="rules"
                              required
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="6" md="6">
                            <v-text-field
                              v-model="editedItem.address.city"
                              id="city"
                              label="Cidade*"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.address.district"
                              id="district"
                              label="Bairro*"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.address.street"
                              id="street"
                              label="Rua e numero*"
                              :rules="rules"
                              required
                            >
                            </v-text-field>

                            <v-text-field
                              v-model="editedItem.location"
                              id="location"
                              label="Coordenadas*"
                              :rules="locationRules"
                              required
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                      :disabled="!valid"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon small @click="deleteItem(item)">delete</v-icon>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  GetDrugstores,
  InsertDrugstores,
  UpdateDrugstores,
  DeleteDrugstores
} from "../../graphql/drugstore.gql";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

export default {
  name: "drugstores-list",
  data: () => ({
    dialog: false,
    valid: true,
    lazy: false,
    errorCep: false,
    filters: [
      { name: null },
      { description: null },
      { hasdelivery: null },
      { enabled: true }
    ],
    headers: [
      { text: "Nome", value: "name" },
      { text: "Descrição", value: "description" },
      { text: "Entrega em andamento", value: "hasdelivery" },
      { text: "CEP", value: "address.zip" },
      { text: "Cidade", value: "address.city" },
      { text: "Bairro", value: "address.district" },
      { text: "Rua e numero", value: "address.street" },
      { text: "Ações", value: "action", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      id: null,
      name: "",
      description: "",
      enabled: true,
      hasdelivery: false,
      address: {
        zip: "",
        city: "",
        state: "",
        street: "",
        district: ""
      },
      location: ""
    },
    defaultItem: {
      id: null,
      name: "",
      description: "",
      enabled: true,
      hasdelivery: false,
      address: {
        zip: "",
        city: "",
        state: "",
        street: "",
        district: ""
      },
      location: ""
    },
    rules: [v => !!v || "Campo obrigatório!"],
    locationRules: [
      v => !!v || "Campo obrigatório!",
      // eslint-disable-next-line no-useless-escape
      v => /\..+.\,.+.\..+/.test(v) || "Valor inválido, ex: 22.22222,22.22222"
    ],
    cepRules: [
      v => !!v || "Campo obrigatório!",
      v => (v && v.length == 8) || "Valor inválido, ex: 12345678"
    ]
  }),

  apollo: {
    drugstores: {
      query: GetDrugstores,
      variables() {
        return {
          name: this.filters.name
            ? { _ilike: "%" + this.filters.name + "%" }
            : {},
          description: this.filters.description
            ? { _ilike: "%" + this.filters.description + "%" }
            : {},
          hasdelivery: this.filters.hasdelivery
            ? { _eq: this.filters.hasdelivery }
            : {},
          enabled: this.filters.enabled ? { _eq: this.filters.enabled } : {}
        };
      }
    }
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Categoria" : "Editar Categoria";
    }
  },

  mounted: function() {},

  watch: {
    dialog(val) {
      val || this.close();
    },
    "filters.name": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.name = null;
          }
        }
      }
    },
    "filters.description": {
      deep: true,
      handler(val) {
        if (typeof val !== "undefined" && val !== null) {
          if (val.length == 0) {
            this.filters.description = null;
          }
        }
      }
    }
  },

  methods: {
    loadCep: function() {
      var self = this;
      self.errorCep = false;

      if (
        this.editedItem.address.zip &&
        this.editedItem.address.zip.length == 8
      ) {
        Vue.axios
          .get(
            "https://viacep.com.br/ws/" + this.editedItem.address.zip + "/json/"
          )
          .then(response => {
            if (response.data.erro) {
              self.editedItem.address.state = "";
              self.editedItem.address.city = "";
              self.editedItem.address.street = "";
              self.editedItem.address.district = "";
              self.errorCep = true;
              return;
            } else {
              self.editedItem.address.state = "";
              self.editedItem.address.city = response.data.localidade;
              self.editedItem.address.street = response.data.logradouro;
              self.editedItem.address.district = response.data.bairro;
            }
          });
      }
    },

    clear(value) {
      if (!value) {
        return null;
      }
    },

    editItem(item) {
      this.editedIndex = this.$apollo.data.drugstores.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.$apollo.data.drugstores.indexOf(item);
      confirm("Deletar Farmácia?") &&
        this.$apollo.data.drugstores.splice(index, 1) &&
        this.$apollo
          .mutate({
            mutation: DeleteDrugstores,
            variables: {
              id: item.id
            }
          })
          .then(() => {
            this.$swal("Farmácia deletada com sucesso!", "", "success");
          })
          .catch(() => {
            this.$swal("Erro ao deletar farmácia!", "", "error");
          });
    },

    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.street = "";
      this.editedItem.state = "";
      this.editedItem.district = "";
      this.editedItem.city = "";
      this.editedIndex = -1;
    },

    save() {
      let variables = {
        name: this.editedItem.name,
        description: this.editedItem.description,
        enabled: this.editedItem.enabled,
        hasdelivery: this.editedItem.hasdelivery,
        address: this.editedItem.address,
        location: this.editedItem.location
      };

      if (this.editedItem.id !== null) {
        variables.id = this.editedItem.id;
      }

      this.$apollo
        .mutate({
          // Query
          mutation:
            this.editedItem.id !== null ? UpdateDrugstores : InsertDrugstores,
          // Parameters
          variables: variables
        })
        .then(data => {
          if (this.editedItem.id !== null) {
            Object.assign(
              this.$apollo.data.drugstores[this.editedIndex],
              data.data.update_drugstores.returning[0]
            );
          } else {
            this.$apollo.data.drugstores.push(
              data.data.insert_drugstores.returning[0]
            );
          }
          this.close();
          this.$swal("Farmácia salva com sucesso!", "", "success");
        })
        .catch(error => {
          console.log(error);
          this.close();
          this.$swal("Erro ao salvar a farmácia!", "", "error");
        });
    },

    toArray(array) {
      let items = [];
      array.forEach(v => items.push(v));
      return items;
    }
  }
};
</script>

<style lang="stylus"></style>
